/**
 * Where a listing photo should be anchored when a container has to crop it.
 *
 * A listing photo appears in containers of different shapes — a tall card on
 * desktop, a wider one on mobile — so one baked-in crop cannot suit all of
 * them. The listing stores the point the subject sits at and each container
 * crops around it, which is what survives a change of aspect ratio.
 *
 * Falls back to the old fixed guess for listings saved before the focal point
 * existed, so nothing shifts until its owner sets one.
 */
export const DEFAULT_FOCUS = { x: 50, y: 22 };

const clamp = (n) => Math.min(100, Math.max(0, n));

/** @returns {{x: number, y: number}} */
export function readFocus(listing) {
  const x = Number(listing?.photoFocusX);
  const y = Number(listing?.photoFocusY);
  return {
    x: Number.isFinite(x) ? clamp(x) : DEFAULT_FOCUS.x,
    y: Number.isFinite(y) ? clamp(y) : DEFAULT_FOCUS.y,
  };
}

/** The CSS object-position value for a listing's photo. */
export function focusPosition(listing) {
  const { x, y } = readFocus(listing);
  return `${x}% ${y}%`;
}
